/* eslint-disable no-redeclare */
import { z } from 'zod';

export const CampaignPlacement = z.string().min(1);

export type CampaignPlacement = z.infer<typeof CampaignPlacement>;
